import React, { FC } from 'react';
import { TableContainer, TableBody, TableHead, TableRow, TableCell } from '@material-ui/core';
import { HeaderRow, TableCustom } from 'components/Table';
import { dummyZone } from 'utils/dummy';
import BodyRow from './components/BodyRow';

interface Props {
  isLoadingData: boolean;
  zones: ZoneModel[];
  queryString?: string;
  order: 'asc' | 'desc';
  orderBy: string;
  setOrder: React.Dispatch<React.SetStateAction<'asc' | 'desc'>>;
  setOrderBy: React.Dispatch<React.SetStateAction<string>>;
  handleConfirmationDelete: (id: number) => React.MouseEventHandler;
  handleOnUpdate: (id: number) => React.MouseEventHandler;
}

const ZoneTable: FC<Props> = props => {
  const { isLoadingData, zones, order, orderBy, setOrder, setOrderBy, queryString, handleConfirmationDelete, handleOnUpdate } = props;
  const handleRequestSort = (event: React.MouseEvent<unknown>, property: string) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <TableContainer>
      <TableCustom>
        <TableHead>
          <HeaderRow
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            headers={[
              { id: 'name', label: 'Nama Rute', sort: true },
              { id: 'repaymentDay', label: 'Pelunasan', align: 'center', sort: true },
              { label: 'Deskripsi' },
              { label: '' }
            ]}
          />
        </TableHead>
        <TableBody>
          {isLoadingData ? (
            [0, 1, 2, 3].map(index => (
              <BodyRow key={index} isLoading={isLoadingData} zone={dummyZone} onDelete={handleConfirmationDelete(0)} onUpdate={handleOnUpdate(0)} />
            ))
          ) : zones && zones.length > 0 ? (
            zones.map((value, index) => (
              <BodyRow
                key={index}
                isLoading={isLoadingData}
                zone={value}
                onDelete={handleConfirmationDelete(value.id)}
                onUpdate={handleOnUpdate(index)}
              />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} align='center'>
                {queryString ? 'No matching result' : 'Data Tidak Tersedia.'}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </TableCustom>
    </TableContainer>
  );
};

export default ZoneTable;
